var map = {
	"./images/trainers-background-bottom.png": 205,
	"./images/trainers-background-side.png": 206,
	"./images/trainers-background-top.png": 207,
	"./images/trainers-bg-bg.jpg": 208,
	"./images/trainers-logo.png": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;